/**
 * src/api/billing.js
 * Funciones para billing Flow.cl.
 *
 * Flujo:
 * 1. crearCheckout(tier) → {url, customer_id} → redirigir a url (Flow registra tarjeta)
 * 2. Flow redirige a /billing/flow-callback?token=...&tier=...&usuario_id=...
 * 3. Backend verifica + suscribe → redirige a /onboarding
 */
import api from './client'

export const crearCheckout = (tier, ciclo = 'mensual') =>
  api.post('/billing/checkout', { tier, ciclo }).then(r => r.data)

export const getSuscripcion = () =>
  api.get('/billing/suscripcion').then(r => r.data)

// Sonda read-only (admin): verifica los planes en Flow sin mover dinero.
export const verificarPlanesFlow = () =>
  api.get('/billing/admin/planes').then(r => r.data)

// Retiradas del panel el 28-08 (hilo de distribución): el portal del usuario
// logueado, el diagnóstico de Flow y probar-trial eran de la época de
// validación y su propósito está cumplido. Sus endpoints siguen en el backend
// (/billing/portal, /billing/admin/flow-diag, /billing/admin/probar-trial).

// Ejecuta el job diario de mantenimiento (fin de trial, bajas…) a demanda (admin).
export const runMantenimiento = () =>
  api.post('/billing/admin/run-mantenimiento', null, { timeout: 90_000 }).then(r => r.data)

// Reconciliación (admin): consulta Flow y activa las suscripciones ya pagadas
// cuyo webhook no llegó. Idempotente. Sin arg → todas las no-activas.
// forzar=true (exige subscriptionId): activa aunque Flow no confirme el pago
// (discrepancia probada Flow↔banco).
export const reconciliarFlow = (subscriptionId, forzar = false) => {
  const qs = new URLSearchParams()
  if (subscriptionId) qs.set('subscription_id', subscriptionId)
  if (forzar) qs.set('forzar', 'true')
  const s = qs.toString()
  return api.post('/billing/admin/reconciliar' + (s ? `?${s}` : '')).then(r => r.data)
}

// Reasignar (admin): repunta una suscripción pagada (y los usuarios de su tenant)
// a otro tenant, conservando el pago de Flow. Sustituye un tenant defectuoso por
// uno nuevo sin perder el enlace al pago. desactivarOrigen=true da de baja el viejo.
export const reasignarSuscripcion = (subscriptionId, clienteDestino, desactivarOrigen = false) =>
  api.post('/billing/admin/reasignar-suscripcion', null, {
    params: {
      subscription_id: subscriptionId,
      cliente_destino: clienteDestino,
      desactivar_origen: desactivarOrigen,
    },
    timeout: 60_000,
  }).then(r => r.data)

export const completarOnboarding = (data) =>
  api.post('/billing/onboarding', data).then(r => r.data)

export const registerUser = (data) =>
  api.post('/auth/register', data).then(r => r.data)

export const loginUser = (data) =>
  api.post('/auth/login', data).then(r => r.data)

export const getMe = () =>
  api.get('/auth/me').then(r => r.data)

export const cambiarPassword = (actual, nueva) =>
  api.post('/auth/change-password', { actual, nueva }).then(r => r.data)
